import { ProductLineName } from "../../models/products/collection";

export const hasFinial: ProductLineName[] = [
  ProductLineName.MontereyPulleyLift,
  ProductLineName.MontereyAutoTilt,
  ProductLineName.MontereyCrank,
  ProductLineName.MontereyGSeries,
  ProductLineName.Greenwich,
  ProductLineName.GreenwichGSeries
];
